import { createSelector } from 'reselect';

import { rsSelector } from '../root/rsSelector';

/**
 * @todo Удалить селектор
 * @description Данный функционал появился в задаче CD-163541, будет удалён в задаче CD-163575
 */
export const filtersSaveSearchEnabledSelector = createSelector(rsSelector, rs => rs.isFiltersSaveSearchEnabled);
